import { merge } from "lodash";
import moment from "moment";
import { useContext, useRef } from "react";
import { BaseOptionChart } from "src/components/chart";
import useResponsive from "src/hooks/useResponsive";

import Context from "./context";
import { dateXAxisPeriodsFormat } from "./types";
import useDataChart from "./useDataChart";

export default function useOptionsChart() {
	const { state } = useContext(Context);
	const { series } = useDataChart();
	const seriesData = series[0]?.data;

	const isMobile = useResponsive("down", "sm");
	const lastCalculatedValueRef = useRef({});

	const options = merge(BaseOptionChart(), {
		chart: {
			animations: {
				enabled: true
			}
		},
		yaxis: {
			type: "numeric",
			min: 0
		},
		xaxis: {
			type: "category",
			tickAmount: isMobile ? 4 : 8,
			tickPlacement: "on",
			labels: {
				rotate: 0,
				datetimeUTC: false,
				formatter: function (val: any) {
					return moment(val).format(dateXAxisPeriodsFormat.get(state.selectedPeriod));
				}
			}
		},
		tooltip: {
			intersect: false,
			shared: true,
			x: {
				formatter: function (value: any) {
					return moment(seriesData[value - 1]?.x).format(
						dateXAxisPeriodsFormat.get(state.selectedPeriod)
					);
				}
			}
		},
		legend: {
			show: false
		},
		stroke: {
			dashArray: [0, 3, 3, 3, 3],
			curve: "smooth",
			width: 2
		},
		fill: {
			gradient: {
				opacityFrom: [0.4, 0, 0, 0, 0]
			}
		}
	});

	lastCalculatedValueRef.current = options;

	return {
		options
	};
}
